<template>
    <div class="bottom" :class="{'selectt': infoReseauxPersonnalise.select}">
      <div class="container_img_info">
        <img :src="url" class="imageBg" alt="">
        <div class="dot_select" @click="contolSelect()"
          :class="{'dot_select1': infoReseauxPersonnalise.select}">
          <div class="dot_selected" v-if="infoReseauxPersonnalise.select"></div>
        </div>
        <div @click="show = true" class="level is-mobile bgBlur">
          <div class="has-text-white" v-if="infoReseauxPersonnalise.dateDebut">
            <div class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left margin_small">
              </b-icon>
              <div class="media-content is-size-7">
                <label>Période d'affichage :</label>
                <p class="p_size10 has-text-weight-bold">
                  {{'Du ' + infoReseauxPersonnalise.dateDebut +
                    ' au '+ infoReseauxPersonnalise.dateFin}}
                </p>
              </div>
            </div>
          </div>
          <div
            class="level-right"
            v-if="getTarif">
            <h3 class="has-text-weight-bold has-text-white goToLeft">
              {{formatNum(getTarif)}} HT
            </h3>
          </div>
        </div>
      </div>
      <div class="has-background-white topViolet infoBorder">
        <div class="columns is-multiline is-marginless is-mobile leftVert is-gap color-icon">
          <div class="column is-paddingless rightViolet"
               @click="show = true">
            <p class="is-size-7 leftViolet">
              <label class="has-text-default">Nom du réseau</label><br>
              <strong class="p_size12 has-text-link">
                {{infoReseauxPersonnalise.libelle}}
              </strong>
            </p>
          </div>
          <div class="column is-paddingless rightViolet"
               @click="show = true">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content is-size-7">
                <label class="has-text-default">Nombre de faces </label><br>
                <p class="p_size12 has-text-link has-text-weight-bold">
                  {{infoReseauxPersonnalise.nbFaces}}
                </p>
              </div>
            </div>
          </div>
          <div class="column is-12 is-paddingless ml-perso rightViolet"
               @click="show = true"
               v-if="infoReseauxPersonnalise.commentaire">
            <div class="media">
              <div class="media-content">
                <label class="has-text-link has-text-weight-bold p_size14">
                  Commenatire : </label><br>
                <p class="p_size12 has-text-default">
                  {{infoReseauxPersonnalise.commentaire}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <a @click="show = true">
          <p class="p_size14 has-text-centered has-text-white topVert color-plus-info">
            Plus d'informations
          </p>
        </a>
      </div>
      <app-detail-reseaux-personnalise-complet-diapo
        :detailReseauxPerso="infoReseauxPersonnalise"
        v-if="show"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatNum, urlPhoto } from '@/services/opportunite/formatTab';
import detailReseauxPersonnaliseCompletDiapo from './detailReseauxPersonnaliseCompletDiapo';


export default {
  name: 'infoReseauxPersonnalise',
  props: ['infoReseauxPersonnalise'],
  components: {
    appDetailReseauxPersonnaliseCompletDiapo: detailReseauxPersonnaliseCompletDiapo,
  },
  data() {
    return {
      show: false,
      bg: false,
      select: -1,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.infoReseauxPersonnalise.urlPhoto);
    },
    tarif() {
      if (this.infoReseauxPersonnalise.tarifNet) return this.infoReseauxPersonnalise.tarifNet;
      return this.infoReseauxPersonnalise.tarifHT;
    },
    getTarif() {
      let tarifNet = 0;
      let tarifDePose = 0;
      let taxeMunicipale = 0;
      let tarifImpression = 0;
      let tarifHT = 0;
      if (this.infoReseauxPersonnalise.tarifDePose) {
        tarifDePose = this.infoReseauxPersonnalise.tarifDePose;
      }
      if (this.infoReseauxPersonnalise.taxeMunicipale) {
        taxeMunicipale = this.infoReseauxPersonnalise.taxeMunicipale;
      }
      if (this.infoReseauxPersonnalise.tarifImpression) {
        tarifImpression = this.infoReseauxPersonnalise.tarifImpression;
      }
      if (this.infoReseauxPersonnalise.tarifHT) {
        tarifHT = this.infoReseauxPersonnalise.tarifHT;
      }
      if (this.infoReseauxPersonnalise.tarifNet) {
        tarifNet = this.infoReseauxPersonnalise.tarifNet;
        return tarifNet
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
      }
      return tarifHT
        + tarifDePose
        + taxeMunicipale
        + tarifImpression;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.infoReseauxPersonnalise.select = !this.infoReseauxPersonnalise.select;
      if (this.infoReseauxPersonnalise.select) {
        this.add(this.getTarif);
        this.addNbSelect();
      } else {
        this.substract(this.getTarif);
        this.substractNbSelect();
      }
    },
    formatNum(data) {
      return formatNum(data);
    },
  },
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxPersonnalise/infoReseauxPersonnalise.vue